module.exports = function getResource(label, vars = []) {
    let resources = {
        filterBy: 'Filtrer par',
        filter: 'Filtrer',
        resetAllFilters: 'Réinitialiser tous les filtres',
        reset: 'Réinitialiser',
        done: 'Terminé'
    };

    return resources[label];
};
